import { InsertColumnAfterIcon } from '@databases/icons';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS, tooltip } from '@databases/keyboard-shortcuts';
import React from 'react';

import { submenu } from '../../../select-value-menu/state/submenu-state';
import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import {
  ElementAfterShortCutWrapper,
  ElementBeforeIconWrapper,
} from '../../../select-value-menu/ui/components';
import { type SelectionsEffectMenuItemBuilder } from '../types';

export const addFieldRightMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  actions,
  skip
) => {
  if (!context.capabilities.canInsertContent) {
    return skip;
  }

  return () => ({
    key: SELECT_VALUE_MENU_ACTIONS.ADD_FIELD_RIGHT,
    content: context.formatMessage(messages['field-actions.add-right']),
    onClick: () => {
      actions.column.handleInsertFields('after', [context.fieldId]);

      context.closeMenu();
    },
    onMouseEnter: submenu.close,
    elemAfter: (
      <ElementAfterShortCutWrapper tooltip={tooltip(SHORTCUTS.ADD_FIELD_RIGHT.keyMap)} />
    ),
    elemBefore: (
      <ElementBeforeIconWrapper>
        <InsertColumnAfterIcon label="" size="medium" />
      </ElementBeforeIconWrapper>
    ),
  });
};
